import { createContext } from 'react';
import { SessionStoredItem } from '../../storage/session-stored-item';

export type TextDirection = 'rtl' | 'ltr';
const directionItem = new SessionStoredItem<string>('420', 'direction');

export const textDirectionGetter = (element: Element) => {
  const computedStyle = getComputedStyle(element);
  return () => (computedStyle.direction !== 'rtl' ? 'ltr' : 'rtl');
};

export const TextDirectionContext = createContext<() => TextDirection>(() => {
  return directionItem.item as TextDirection;
});

export const useDirectionSwitch = <T>(ltr: T, rtl: T) => {
  return (directionItem.item || 'ltr') === 'ltr' ? ltr : rtl;
};
